import { EOfferType } from './wantType';

export type TGuideList = {
  step: number;
  title: string;
  slider: {
    image: string;
    title: string;
    type: EOfferType | 'all';
    notice: string;
    link: string;
  }[];
  banner?: { mainBanner: IBanners; secondBanner?: IBanners };
};

export interface IBanners extends TBanner {
  type: EBannerType;
}

export enum EBannerType {
  Blue = 'blue',
  Colored = 'colored',
}

export type TBanner = {
  title: string;
  linkBtn: {
    url?: string;
    text: string;
  };
  imageClass: string;
};
